import { AutogenLayoutEDITenderProfileQuickInfo } from "./autogen/AutogenLayoutEdiTenderProfileQuickInfo";

export class EdiTenderProfileQuickInfo extends AutogenLayoutEDITenderProfileQuickInfo {

}
